import { allProPlansIds, customNames, highStakesAdditional } from '../constants';
import React from 'react';
import { IPlan } from '../model';

export const getName = <T extends {
  isAdditional?: boolean,
  additional ?:IPlan,
  display: {
    name: string
  }
}>(plan: T, isSeams?: boolean) => {
  if (plan.isAdditional && plan.additional?.plan_id && allProPlansIds.includes(plan.additional?.plan_id)) return plan.additional?.display.name;
  if (plan.isAdditional && plan.additional?.plan_id && highStakesAdditional.includes(plan.additional?.plan_id)) return plan.additional?.display.name;
  return isSeams
    ? customNames[plan.additional?.plan_id || ''] ?? plan.additional?.display.name
    : <>{plan.display.name} {plan.isAdditional ? <> and <br/>{plan.additional?.display.name}</> : ''}</>
}
